<cx-generic-link
    [url]="data.url"
    [target]="data.target"
>
    <img 
        class="quick-order-icon quick-order-icon--blue"
        src="../../../../../assets/icons/qc_shopping_bag_blue.svg" 
        alt="Quick Order">

    <img 
        class="quick-order-icon quick-order-icon--white"
        src="../../../../../assets/icons/qc_shopping_bag_white.svg" 
        alt="Quick Order">

    <span class="action-label">{{ data.linkName }}</span>
</cx-generic-link>